import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { FundingCategories } from "@/components/FundingCategories";
import { Calculator } from "@/components/Calculator";
import { FAQ } from "@/components/FAQ";
import { Resources } from "@/components/Resources";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/toaster";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <div id="funding-categories">
        <FundingCategories />
      </div>
      <HowItWorks />
      <Calculator />
      <FAQ />
      <Resources />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

export default Index;